export class SignageEditModel {
    public id: number;
    public companyId: number;
    public facilityId: number;
    public kioskId: number;
    public originalContentFileName: string;
    public originalThumbnailFileName: string;
    public contentFileName: string;
    public contentFileType: string;
    public contentFileUrl: string;
    public thumbnailFileOriginalName: string;
    public thumbnailFileName: string;
    public thumbnailFileUrl: string;
    public title: string;
    public description: string;
    public internalDescription: string;
}
